import React from "react";
import LocationDark from "@Icons/LocationDark";
import WalkingDark from "@Icons/WalkingDark";
import TrainDark from "@Icons/TrainDark";
import DriveDark from "@Icons/DriveDark";
import formatNearbyDistance from "../../utils/formatNearbyDistance";
import { calculateTravelTimes } from "../../utils/calculateTravelTimes";
import styles from "./NearbyDistanceInfo.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useIsDesktop from "hooks/useIsDesktop";

interface NearbyDistanceInfoProps {
  nearbyDistanceMiles: number;
  regionType?: string;
  regionName?: string;
  isGridView?: boolean;
}

const MILES_TO_KM = 1.60934;

const NearbyDistanceInfo: React.FC<NearbyDistanceInfoProps> = ({
  nearbyDistanceMiles,
  regionType,
  regionName = "",
  isGridView = false,
}) => {
  const { t } = useTranslationHook();
  const isDesktop = useIsDesktop();
  const distanceValue = formatNearbyDistance(nearbyDistanceMiles);
  const distanceKm = nearbyDistanceMiles * MILES_TO_KM;
  const { walkingMinutes, busMinutes, carMinutes } = calculateTravelTimes(distanceKm);

  const universityText = t("searchpage.searchlist.searchlistitem.university");

  let locationLabel = "you";
  let distancePrefix = "away from"; // Default for "you"

  if (regionType === "establishment") {
    locationLabel = universityText;
    distancePrefix = "from";
  }
  if (regionType === "sublocality") {
    locationLabel = regionName;
    distancePrefix = "from";
  }

  return (
    <div
      className={formatClassNames(
        styles.container,
        isGridView && styles.gridView,
        isDesktop && styles.desktop,
      )}
      data-testid="nearby-distance-info"
    >
      <span className={styles.distanceText}>
        <LocationDark />
        {`${distanceValue} mi ${distancePrefix} ${locationLabel}`}
      </span>
      <span className={styles.separator}>|</span>
      <span className={styles.travelTimes}>
        <span className={styles.travelMode}>
          <DriveDark />
          <span>{carMinutes}m</span>
        </span>
        <span className={styles.travelMode}>
          <TrainDark />
          <span>{busMinutes}m</span>
        </span>
        <span className={styles.travelMode}>
          <WalkingDark />
          <span>{walkingMinutes}m</span>
        </span>
      </span>
    </div>
  );
};

export default wrapperHOC(NearbyDistanceInfo, {
  componentName: "NearByDistanceInfo-NearbyPage",
  showForChina: true,
});
